import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'
import BusinessReportsTable from './reports-components/BusinessReportsTable'

const Reports = () => {
  return (
    <React.Fragment>
    <Helmet title="Reportes" />
    <Container fluid className="p-0 mco-fade-in">
      <Row>
        <Col lg="12">
          <BusinessReportsTable />
        </Col>
      </Row>
    </Container>
    </React.Fragment>
  )
}

export default Reports